/**
 * Audit C-4 — query retry policy helpers.
 * Lives in its own file so QueryProvider.tsx remains a component-only module
 * (react-refresh/only-export-components).
 *
 * Behaviour:
 *   - 4xx (incl. 401/403/404) → never retry. Validation / auth / not-found
 *     responses don't benefit from a retry.
 *   - 5xx + network failures (ApiError.status === 0) → retry up to
 *     MAX_QUERY_RETRIES times.
 *   - Exponential backoff: 1s → 2s → 4s …, capped at 30s, matching the
 *     TanStack Query official cookbook.
 */

import { ApiError } from "@/shared/api/errors.js";

export const MAX_QUERY_RETRIES = 2;

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError) {
    if (error.isClientError && error.status >= 400 && error.status < 500) {
      return false;
    }
  }
  return failureCount < MAX_QUERY_RETRIES;
}

export function queryRetryDelay(attemptIndex: number): number {
  return Math.min(1_000 * 2 ** attemptIndex, 30_000);
}
